// extracted by mini-css-extract-plugin
export default {"searchContainer":"CertificateContainer_searchContainer__RRyv-","tableWrapper":"CertificateContainer_tableWrapper__wdrf7"};